import PropTypes from "prop-types";
import React from "react";
import IconCheckmarkAlt from "../../icons/IconCheckmarkAlt";
import { Card, CardIcon, Cell, Grid, Text } from "./styled/live-rdc-value-grid";

function LiveRdcValueGrid({ items }) {
  return (
    <Grid>
      {items.map((item) => (
        <Cell key={item}>
          <Card>
            <CardIcon>
              <IconCheckmarkAlt />
            </CardIcon>
            <Text>{item}</Text>
          </Card>
        </Cell>
      ))}
    </Grid>
  );
}

LiveRdcValueGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};

export default LiveRdcValueGrid;
